import { render, staticRenderFns } from "./EditPhotoGalleryComponent.vue?vue&type=template&id=29b03ca8"
import script from "./EditPhotoGalleryComponent.vue?vue&type=script&lang=ts"
export * from "./EditPhotoGalleryComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports